const VITE_PRODUCTION_MODE = "production"
const VITE_STAGING_MODE = "staging"
const VITE_DEVELOPMENT_MODE = "development"
const VITE_TEST_MODE = "test"

export const isStaging = () => import.meta.env.MODE === VITE_STAGING_MODE

export const isProduction = () => import.meta.env.MODE === VITE_PRODUCTION_MODE

export const isTesting = () => import.meta.env.MODE === VITE_TEST_MODE

export const isDevelopment = () =>
  import.meta.env.MODE === VITE_DEVELOPMENT_MODE

export const isAutomationEnv = () =>
  import.meta.env.VITE_AUTOMATION_ENV === "true"

export const isDeploymentEnv = () => isStaging() || isProduction()

export const getGtmContainerId = () => import.meta.env.VITE_GTM_CONTAINER

export const isAnalyticsEnabled = () => !!getGtmContainerId()
